"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../../lib/fetch");
var ratelimit_error_1 = require("./ratelimit-error");
var shared_dispatcher_1 = require("./shared-dispatcher");
function default_1(config) {
    function dispatch(url, body) {
        return (0, fetch_1.fetch)(url, {
            keepalive: config === null || config === void 0 ? void 0 : config.keepalive,
            headers: (0, shared_dispatcher_1.createHeaders)(config === null || config === void 0 ? void 0 : config.headers),
            method: 'post',
            body: JSON.stringify(body),
            // @ts-ignore - not in the ts lib yet
            priority: config === null || config === void 0 ? void 0 : config.priority,
        }).then(function (res) {
            var _a;
            if (res.status >= 500) {
                throw new Error("Bad response from server: ".concat(res.status));
            }
            if (res.status === 429) {
                var retryTimeoutStringSecs = (_a = res.headers) === null || _a === void 0 ? void 0 : _a.get('x-ratelimit-reset');
                var retryTimeoutMS = retryTimeoutStringSecs
                    ? parseInt(retryTimeoutStringSecs) * 1000
                    : 5000;
                throw new ratelimit_error_1.RateLimitError("Rate limit exceeded: ".concat(res.status), retryTimeoutMS);
            }
        });
    }
    return {
        dispatch: dispatch,
    };
}
exports.default = default_1;
//# sourceMappingURL=fetch-dispatcher.js.map